import { render, staticRenderFns } from "./sortBox.vue?vue&type=template&id=433887d5&scoped=true&"
import script from "./sortBox.vue?vue&type=script&lang=js&"
export * from "./sortBox.vue?vue&type=script&lang=js&"
import style0 from "./sortBox.vue?vue&type=style&index=0&id=433887d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433887d5",
  null
  
)

export default component.exports